const products = {
    FLY: 'Flight',
    STAY: 'Hotel',
    DRIVE: 'Car',
    PACKAGE: 'Package'
};
const productsType = {
    FLY: 'FLY',
    STAY: 'STAY',
    DRIVE: 'DRIVE',
    PACKAGE: 'PACKAGE'
};
const mapPinType = {
    AIRPORT: 'AIRPORT',
    ATTRACTION: 'ATTRACTION',
    BEACH: 'BEACH',
    CITY: 'CITY',
    HOTEL: 'HOTEL',
    MUSEUM: 'MUSEUM',
    POI: 'POI',
    RESTAURANT: 'RESTAURANT',
    MOUNTAIN: 'MOUNTAIN',
    PARK: 'PARK',
    ACTIVITY: 'ACTIVITY'
};
const viewType = {
    STAYDETAILS: 'STAYDETAILS',
    STAYLISTINGS: 'STAYLISTINGS',
    FLYDETAILS: 'FLYDETAILS',
    FLYLISTINGS: 'FLYLISTINGS',
    DRIVE: 'DRIVE',
    PORTAL: 'PORTAL',
    CHECKOUT: 'CHECKOUT',
    LANDING: 'LANDING',
    ITINERARY: 'ITINERARY'
};
const appNameMap = {
    relax: [
        viewType.STAYLISTINGS
    ],
    'relax-at': [
        viewType.STAYDETAILS
    ],
    'travel-itinerary': [
        viewType.ITINERARY
    ],
    'drive-search-responsive': [
        viewType.DRIVE
    ],
    'fly-search': [
        viewType.FLYDETAILS,
        viewType.FLYLISTINGS
    ],
    'next-landing': [
        viewType.LANDING
    ],
    'cart-checkout': [
        viewType.CHECKOUT
    ]
};
const viewTypeToProductIdMap = {
    [viewType.PORTAL]: -1,
    [viewType.FLYDETAILS]: 1,
    [viewType.FLYLISTINGS]: 1,
    [viewType.STAYDETAILS]: 5,
    [viewType.STAYLISTINGS]: 5,
    [viewType.DRIVE]: 8
};
export { appNameMap, mapPinType, products, productsType, viewType, viewTypeToProductIdMap };
